var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBullseye = function SvgBullseye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 16a14 14 0 1 0-28 0 14 14 0 0 0 28 0M0 16a16 16 0 1 1 32 0 16 16 0 0 1-32 0m16 8a8 8 0 1 0 0-16.001A8 8 0 0 0 16 24m0-18a10 10 0 1 1 0 20 10 10 0 0 1 0-20m0 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4m0-6a4 4 0 1 1 0 8 4 4 0 0 1 0-8"
  })));
};
export default SvgBullseye;